import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './list-item.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'


initializeIconsByRole({
  'cse-list-item.bullet': { name: 'circle', style: 'solid' },
})

export const listItemVariants = ['unstyled', 'bullet', 'custom-icon'] as const
export type listItemVariantTypes = typeof listItemVariants

@customElement('cse-list-item')
export class CSEListItem extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: String })
  variant: listItemVariantTypes[number] = 'unstyled'

  @property({ type: String, attribute: 'icon-name' })
  iconName = 'star'

  @property({ type: String, attribute: 'icon-style' })
  iconStyle = 'regular'

  private renderIcon = () => {
    if (this.variant === 'bullet') {
      return html`<cse-icon class="bullet" icon-role="cse-list-item.bullet"></cse-icon>`
    }

    if (this.variant === 'custom-icon') {
      return html`
        <cse-icon
          class="custom-icon"
          icon-name="${this.iconName}"
          icon-style="${this.iconStyle}"
          size="xxs"
        ></cse-icon>
      `
    }

    return nothing
  }

  override render() {
    return html`
      <li class="cse-list-item">
        <div class="item font-body">
          ${this.renderIcon()}
          <slot></slot>
        </div>
      </li>
    `
  }
}
